import { Button, Image, Popover, Select, Tabs, Input, message, Tree } from "antd"
import { forwardRef, useCallback, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react"
import API, { commonApiInvoker } from "@api/api"
import { LoadingOutlined, PlusOutlined, SearchOutlined, CaretDownOutlined } from '@ant-design/icons';
import ImageItem from "../ImageItem"
import styles from "./index.module.scss"
import * as _ from "underscore";
import Utils from "@utils/utils"
import { IMAGE_TYPE, BATCH_IMAGES_TYPE, RESOURCE_TYPE, RESOURCE_PARAMS, SELECT_ORG_TYPE } from "@utils/CONST"
import PSAIModal from "@PSAIComponents/PSAIModal";
import CustomModelForm from "@view/page/selfModelFakeLeft/CustomModelForm";
import ModelFilterSelection from "@view/page/selfModelFakeLeft/ModelFilterSelection";
import ModelFilterSelectionNew from "@view/page/selfModelFakeLeft/ModelFilterSelection_new";
import Iconfont from '@utils/Iconfont';
import { CloseOutlined } from '@ant-design/icons';
import SelectionFilterSearch from '@view/page_v3/LeftComp/components/SelectionFilterSearch'
import UploadRequirements from "@view/page_v3/LeftComp/components/UploadRequirements"
import eventBus from '@utils/eventBus'
import MoveFolderModal from "@view/page_v3/MaterialManage/components/MoveFolderModal";
import MaterialUploadModal from "@view/page_v3/MaterialManage/components/MaterialUploadModal";
import EnterpriseEmpty from "@view/page_v3/MaterialManage/components/EnterpriseEmpty";
import ReferFolderCard from "@view/page_v3/LeftComp/components/ReferFolderCard";
import { AppContext } from "@utils/AppContext";
const fallback = require('@assets/images/fallback.png')
const PAGE_SIZE = 60

const getResourceData = (projectType) => {
    return projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ||
        projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? {
        func: "model",
        type: "tryOn",
    } : projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? {
        func: "model",
        type: "productDetail",
    } : projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? {
        func: "model",
        type: "person",
    } : projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? {
        func: "model",
        type: "background",
    } : {}
}

const getResourceTypeByProjectType = (projectType) => {
    if (projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH) return RESOURCE_TYPE.MODEL
    if (projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) return RESOURCE_TYPE.MODEL_SCENE
    if (projectType == BATCH_IMAGES_TYPE.TRYON_BATCH || projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) return RESOURCE_TYPE.TRYON_MODEL
    return RESOURCE_TYPE.TRYON_MODEL
}

const getResourceQueryParams = (projectType) => {
    const resourceType = getResourceTypeByProjectType(projectType)
    return {
        ...(RESOURCE_PARAMS[resourceType] || {}),
        ...(getResourceData(projectType) || {}),
    }
}

const getDeleteResourceLabel = (projectType) => {
    if (projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) return '背景图'
    if (projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH || projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH) return '模特图'
    return '参考图'
}

const getUploadSampleTypeByProjectType = (projectType) => {
    if (projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) return 'modelBg'
    if (projectType == BATCH_IMAGES_TYPE.TRYON_BATCH) return 'cloth'
    if (projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH) return 'smartdetail'
    return 'model'
}

const getSelectKey = (item) => item?.key || item?.name || item?.id

const transformFolderTreeData = (list) => {
    if (!Array.isArray(list)) return []
    return list.map((item) => {
        const node = {
            key: item.id,
            title: item.name,
            count: item.imageCount ?? 0,
            depth: item.depth ?? 0,
            isLeaf: !item.children || item.children.length === 0,
        }
        if (item.children && item.children.length > 0) {
            node.children = transformFolderTreeData(item.children)
        }
        return node
    })
}

const getAncestorKeysByFolderId = (list, targetId, ancestors = []) => {
    if (!Array.isArray(list) || targetId == null) return null
    for (const item of list) {
        const itemId = item?.id
        const nextAncestors = [...ancestors, itemId]
        if (String(itemId) === String(targetId)) {
            return ancestors
        }
        if (Array.isArray(item?.children) && item.children.length > 0) {
            const found = getAncestorKeysByFolderId(item.children, targetId, nextAncestors)
            if (found) return found
        }
    }
    return null
}

const ImgToVideoContent = (props) => {
    const { type, setPrompt, resourceType } = props
    const [force, updateForce] = useState()
    const [promptList, setPromptList] = useState([])
    const [promptOpen, setPromptOpen] = useState(false)
    const [title, setTitle] = useState('')
    const [desc, setDesc] = useState('')
    const [editId, setEditId] = useState(null)

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.IMAGE_TO_VIDEO) return
        if (!RESOURCE_PARAMS[resourceType]) return
        commonApiInvoker(API.getCustomResources2({ ...RESOURCE_PARAMS[resourceType], pageIndex: 1, pageSize: 50000 })).then(res => {
            setPromptList(res?.items || [])
        })
    }, [force, resourceType])

    useEffect(() => {
        if (resourceType != RESOURCE_TYPE.IMAGE_TO_VIDEO) return
        const handler = () => updateForce({})
        eventBus.on('updateImgToVideoPrompt', handler)
        return () => eventBus.off('updateImgToVideoPrompt', handler)
    }, [resourceType])

    const promptGroups = useMemo(() => ([
        { key: 'subject', title: '主体', options: ['女人', '男人', '男孩', '女孩'] },
        { key: 'action', title: '动作', options: ['服饰展示', '往前行走', '右手抬起', '模特台步', '身体自然左右晃动', '手自然插入口袋'] },
        { key: 'camera', title: '运镜', options: ["镜头固定", "镜头从左往右", "镜头从右往左", "镜头推进", "镜头拉远", "镜头上摇", "镜头下摇", "环绕运镜", "原地旋转展示", "左旋推进", "右旋推进", "推进上移", "推进拉远"] }
    ]), [])

    const handleRemove = (record) => {
        PSAIModal.confirm({
            title: `确定删除这段提示词吗？`,
            onOk() {
                return commonApiInvoker(API.removeCustomMaterial({ id: record.id })).then(() => {
                    message.success('删除成功')
                    updateForce({})
                })
            }
        })
    }

    const handleAddPrompt = async () => {
        if (!desc) return message.error('请输入描述')
        const res = await API.saveCustomMaterialv2({
            ...(editId ? { id: editId } : {}),
            func: IMAGE_TYPE.IMAGE_TO_VIDEO,
            type: 'image2VideoPrompt',
            image: desc?.trim(),
            attr: { title: title?.trim() || '未命名标题' }
        })
        if (res?.code != 0) throw new Error(res?.message)
        setPromptOpen(false)
        setEditId(null)
        updateForce({})
    }

    return <div className={styles.ImgToVideoContent}>
        {
            type == 'prompt' ? <div className={`${styles.ImgToVideoContent_prompt} _none_scrollbar`}>
                {promptGroups.map(group => <div key={group.key} className={styles.ImgToVideoContent_promptGroup}>
                    <div className={styles.ImgToVideoContent_promptTitle}>{group.title}</div>
                    <div className={styles.ImgToVideoContent_promptOptions}>
                        {group.options.map(opt => <Button key={`${group.key}_${opt}`} className={`${styles.ImgToVideoContent_promptBtn}`} onClick={() => setPrompt(prev => (prev ? `${prev}${opt}，` : `${opt}，`))}>{opt}</Button>)}
                    </div>
                </div>)}
            </div> : type == 'mine' ? <div className={`${styles.ImgToVideoContent_mine} _none_scrollbar`}>
                <Button className={styles.ImgToVideoContent_mineAddBtn} onClick={() => { setEditId(null); setTitle(''); setDesc(''); setPromptOpen(true) }}><Iconfont type="icon-general_dd" className={styles.Icon} /> 新增提示词</Button>
                {promptList?.map(item => <div key={item.key} className={styles.ImgToVideoContent_mineItem} onClick={() => setPrompt(item.imageUrl)}>
                    <div className={styles.ImgToVideoContent_mineHeader}>
                        <div className={styles.ImgToVideoContent_mineActions}>
                            <Iconfont type="icon-editOutlined" className={styles.Icon} onClick={(e) => { e.stopPropagation(); setEditId(item.id); setTitle(item.attr?.title || ''); setDesc(item.imageUrl || ''); setPromptOpen(true) }} />
                            <Iconfont type="icon-DeleteOutlined" className={styles.Icon} onClick={(e) => { e.stopPropagation(); handleRemove(item) }} />
                        </div>
                        <div className={styles.ImgToVideoContent_mineTitle}>{item.attr?.title}</div>
                    </div>
                    <div className={styles.ImgToVideoContent_mineDesc}>{item.imageUrl}</div>
                </div>)}
            </div> : null
        }
        <PSAIModal title="新增提示词" open={promptOpen} maskClosable={false} maxWidth={528} onCancel={() => setPromptOpen(false)} onOk={handleAddPrompt} getContainer={"body"} zIndex={10000}>
            <div className={styles.ImgToVideoContent_modalForm}>
                <div className={styles.ImgToVideoContent_modalItem}>
                    <Input value={title} onChange={(e) => setTitle(e.target.value)} placeholder="请输入描述标题（选填）" className={styles.ImgToVideoContent_modalInput} />
                </div>
                <div className={styles.ImgToVideoContent_modalItem}>
                    <div className={styles.ImgToVideoContent_modalLabel}>描述</div>
                    <Input.TextArea value={desc} onChange={(e) => setDesc(e.target.value)} placeholder="请输入描述" maxLength={800} autoSize={{ minRows: 8, maxRows: 8 }} className={styles.ImgToVideoContent_modalTextArea} />
                </div>
            </div>
        </PSAIModal>
    </div>
}

const CustomPoseList = forwardRef((props, ref) => {
    const removeRecordsFromList = useCallback((records = []) => {
        if (!records.length) return
        const removeIdSet = new Set(records.map(item => item?.id))
        setList(prev => prev.filter(item => !removeIdSet.has(item?.id)))
    }, [])

    useImperativeHandle(ref, () => ({
        refresh: () => updateForce(),
        removeRecords: (records = []) => removeRecordsFromList(records),
        uploadFiles: (fileList) => doUploadFiles(fileList),
        onFavor: (record, favor) => {
            setList(pre => {
                const temp = [...pre]
                const item = temp.find(item => item.id == record.id)
                if (!item) return temp
                item.isFavorite = favor
                return [...temp]
            })
        }
    }))
    const [loading, setLoading] = useState(false)
    const [list, setList] = useState([])
    const listRef = useRef([])
    const [force, setForce] = useState(0)
    const updateForce = useCallback(() => setForce(prev => prev + 1), [])
    const isLoop = useRef()
    const isMounted = useRef(true)
    const pendingAutoSelectIdRef = useRef(null) // 暂存自定义模特、用于自动选中
    const { globalOrgInfo } = useContext(AppContext)
    const hasOrg = globalOrgInfo?.orgList?.length > 1
    const [folderList, setFolderList] = useState([])
    const [folderTotal, setFolderTotal] = useState(0)
    const [activeFolder, setActiveFolder] = useState('refImage_all')
    const [activeFolderName, setActiveFolderName] = useState('全部参考图')
    const [folderOpen, setFolderOpen] = useState(false)
    const [expandedKeys, setExpandedKeys] = useState([])
    const [customKeyword, setCustomKeyword] = useState('')
    const [pageIndex, setPageIndex] = useState(1)
    const [hasMore, setHasMore] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const [listLoading, setListLoading] = useState(false)
    const [moveOpen, setMoveOpen] = useState(false)
    const [shareOpen, setShareOpen] = useState(false)
    const [uploadModalOpen, setUploadModalOpen] = useState(false)
    const [currentMoveResId, setCurrentMoveResId] = useState('')
    const showEnterpriseEmpty = props.materialScope === 'enterprise' && globalOrgInfo?.isPersonal
    const customByMaterialList = useMemo(() => {
        return props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
            props.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ||
            props.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
            props.projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH
    }, [props.projectType])
    const treeData = useMemo(() => transformFolderTreeData(folderList), [folderList])
    const requestIdRef = useRef(0)
    const loadingMoreRef = useRef(false)

    const formatSimpleList = useCallback((items, isCustom = true) => {
        return (items || [])
            .filter(item => !String(item?.name || '').includes("_default_style"))
            .map(item => ({
                ...item,
                key: getSelectKey(item),
                isFavorite: item?.attr?.isFavorite,
                isCustom,
                attr: {
                    ...(item?.attr || {}),
                    // materialList 标题来自 item.name，映射到统一展示字段
                    title: item?.name || item?.attr?.title || '',
                    custom: isCustom
                }
            }))
    }, [])

    useEffect(() => {
        return () => {
            isMounted.current = false
        }
    }, [])

    const loopFunc = () => {
        updateForce()
        if (isLoop.current && isMounted.current) {
            setTimeout(() => {
                loopFunc()
            }, 2000)
        }
    }

    useEffect(() => {
        if (props.activeKey != "custom" && props.activeKey != "enterpriseCustom") return
        props.onChange(list.filter(item => (item?.attr && "maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true)))
    }, [props.activeKey, list])

    useEffect(() => {
        listRef.current = list
    }, [list])

    useEffect(() => {
        const notSucc = !!list.find(item => (item?.attr && "maskStatus" in item.attr ? item.attr?.maskStatus != "succeeded" : false))
        if (notSucc) {
            if (!isLoop.current) {
                isLoop.current = true
                // loopFunc()
            }
        } else {
            if (isLoop.current) {
                isLoop.current = false
            }
        }
    }, [list])

    useEffect(() => {
        loadingMoreRef.current = loadingMore
    }, [loadingMore])

    const loadCustomListPage = useCallback((targetPageIndex, reset = false) => {
        const data = getResourceData(props.projectType)
        const resourceType = getResourceTypeByProjectType(props.projectType)
        if (showEnterpriseEmpty) return
        if (loadingMoreRef.current && !reset) return
        const requestId = requestIdRef.current + 1
        requestIdRef.current = requestId
        if (reset) {
            setPageIndex(1)
            setHasMore(false)
            setListLoading(true)
        } else {
            setLoadingMore(true)
        }
        if (customByMaterialList) {
            const folderId = activeFolder === 'refImage_all' ? '' : activeFolder
            commonApiInvoker(API.materialList({
                scope: props.materialScope || 'personal',
                folderId,
                keyword: customKeyword,
                pageIndex: targetPageIndex,
                pageSize: PAGE_SIZE,
                withAttr: true,
                func: data.func,
                type: data.type,
            })).then(res => {
                if (requestIdRef.current !== requestId) return
                const folders = (res?.subFolders || []).map(item => ({ ...item, type: 'folder' }))
                const images = res?.images || {}
                const total = images.total || 0
                const items = images?.items ?? []
                const list2 = formatSimpleList(items, true)
                if (reset) {
                    setList([...folders, ...list2])
                } else {
                    setList(prev => {
                        const prevFolders = prev.filter(item => item.type === 'folder')
                        const prevImages = prev.filter(item => item.type !== 'folder')
                        return [...prevFolders, ...prevImages, ...list2]
                    })
                }
                setPageIndex(targetPageIndex)
                setHasMore(targetPageIndex * PAGE_SIZE < total)
            }).finally(() => {
                if (requestIdRef.current !== requestId) return
                setLoadingMore(false)
                setListLoading(false)
            })
            return
        }
        commonApiInvoker(API.getCustomResources2({
            ...data,
            pageIndex: targetPageIndex,
            pageSize: PAGE_SIZE
        })).then(res => {
            if (requestIdRef.current !== requestId) return
            const total = res?.total || 0
            const nextList = formatSimpleList(res?.items ?? [], true)
            if (reset) {
                setList(nextList)
            } else {
                setList(prev => [...prev, ...nextList])
            }
            if (pendingAutoSelectIdRef.current != null) {
                const source = reset ? nextList : [...listRef.current, ...nextList]
                const record = source.find(item => item?.id == pendingAutoSelectIdRef.current)
                if (record) {
                    pendingAutoSelectIdRef.current = null
                    props.onClick?.(record)
                }
            }
            setPageIndex(targetPageIndex)
            setHasMore(targetPageIndex * PAGE_SIZE < total)
        }).finally(() => {
            if (requestIdRef.current !== requestId) return
            setLoadingMore(false)
            setListLoading(false)
        })
    }, [
        props.projectType,
        props.materialScope,
        customByMaterialList,
        activeFolder,
        customKeyword,
        formatSimpleList,
        props.onClick,
        showEnterpriseEmpty,
    ])

    useEffect(() => {
        if (showEnterpriseEmpty) {
            setList([])
            setFolderList([])
            setFolderTotal(0)
            setHasMore(false)
            setLoadingMore(false)
            setListLoading(false)
            return
        }
        loadCustomListPage(1, true)
    }, [force, props.projectType, props.materialScope, customByMaterialList, activeFolder, customKeyword, loadCustomListPage, showEnterpriseEmpty])

    useEffect(() => {
        if (!customByMaterialList) return
        if (showEnterpriseEmpty) return
        API.materialFolderTree({ scope: props.materialScope || 'personal' }).then((res) => {
            if (res?.code === 0) {
                const tree = Array.isArray(res?.data) ? res.data : []
                setFolderList(tree)
                setFolderTotal(res?.attr?.total ?? 0)
                return
            }
            setFolderList([])
            setFolderTotal(0)
        }).catch(() => {
            setFolderList([])
            setFolderTotal(0)
        })
    }, [force, customByMaterialList, props.materialScope, showEnterpriseEmpty])

    useEffect(() => {
        if (!customByMaterialList) return
        if (!folderList?.length) return
        expandFolderAncestors(activeFolder)
    }, [customByMaterialList, folderList, activeFolder, expandFolderAncestors])

    const handleListScroll = useCallback((e) => {
        const target = e.currentTarget
        const reachBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 80
        if (!reachBottom) return
        if (!hasMore || loadingMore) return
        loadCustomListPage(pageIndex + 1, false)
    }, [hasMore, loadingMore, pageIndex, loadCustomListPage])

    const [totalNum, setTotalNum] = useState(0)
    const [succNum, setSuccNum] = useState(0)
    const uploadFileWithAntispamId = (file) => {
        return Utils.checkImageIslegal(file, 1).then(res => {
            if (!res) return false
            if (!res.isLegal) {
                PSAIModal.confirm({
                    content: '经检测，您上传的内容涉嫌违规，已进行屏蔽处理，人工审核会对图片进行复核。',
                    okText: '重新上传',
                    cancelText: '取消',
                    onOk() {
                        Utils.openFile().then((res) => {
                            if (res) beforeUpload(res)
                        })
                    },
                    onCancel() { },
                })
                return false
            } else {
                const { imageAntispamId, data } = res
                return {
                    url: data,
                    imageAntispamId
                }
            }
        }).catch((err) => {
            message.error(err.message)
        })
    }
    function removeExtension(filename) {
        if (filename === '.' || filename === '..') return filename;

        const lastDot = filename.lastIndexOf('.')
        if (lastDot === -1 || lastDot === 0) return filename;

        return filename.substring(0, lastDot);
    }
    async function doUploadFiles(fileList) {
        if (!fileList?.length) return []
        if (fileList.length > 30) {
            message.warning("每次最多上传30张图")
            fileList = fileList.slice(0, 30)
        }
        const selectedKeys = []
        const uploadedItems = []
        setSuccNum(0)
        setTotalNum(fileList.length)
        setLoading(true)
        for (let file of fileList) {
            const name = removeExtension(file.name)
            let isNromal = false
            isNromal = await Utils.validateImageFile(file)
            
            if (!isNromal) continue
            const resizeRes = await Utils.resizeImageFileMaxByAliyunBy(file, 4096)
            if (!resizeRes || !resizeRes.success) { message.warning(resizeRes?.message); continue; }
            file = resizeRes.file
            try {
                const res = await uploadFileWithAntispamId(file)
                if (!res) continue
                const { url } = res
                uploadedItems.push({
                    imageUrl: url,
                    name: `${name}`,
                    folderId: customByMaterialList ? (activeFolder === 'refImage_all' ? '' : activeFolder) : '',
                    scope: props.materialScope || 'personal',
                    attr: {
                        title: `${name}`,
                    },
                })
                setSuccNum(pre => pre + 1)
            } catch (err) {
                console.error(err)
            }
        }
        if (uploadedItems.length > 0) {
            try {
                const saveRes = await API.materialResBatchSave({ items: uploadedItems })
                if (saveRes?.code != 0) throw new Error(saveRes?.message)
                const resourceParams = getResourceQueryParams(props.projectType)
                const listRes = await commonApiInvoker(API.materialList({
                    scope: props.materialScope || 'personal',
                    folderId: customByMaterialList ? (activeFolder === 'refImage_all' ? '' : activeFolder) : '',
                    keyword: customKeyword,
                    pageIndex: 1,
                    pageSize: PAGE_SIZE,
                    withAttr: true,
                    func: resourceParams.func,
                    type: resourceParams.type,
                }))
                const images = listRes?.images?.items || []
                uploadedItems.forEach((uploadItem) => {
                    const hit = images.find(img => img?.imageUrl === uploadItem.imageUrl || img?.name === uploadItem.name)
                    if (!hit) return
                    props.onClick({ ...hit, attr: { ...(hit?.attr || {}), custom: true } })
                    const selectKey = getSelectKey(hit)
                    if (selectKey) selectedKeys.push(selectKey)
                })
            } catch (err) {
                message.error(err?.message || '上传失败')
            }
        }
        updateForce()
        setLoading(false)
        return selectedKeys
    }

    const uploadDebounce = useCallback(_.debounce((file, fileList) => {
        doUploadFiles(fileList)
    }, 100), [props.projectType])
    const beforeUpload = async (file, fileList) => {
        uploadDebounce(file, fileList)
        return false
    }
    const handleDrop = async (e) => {
        e.stopPropagation()
        if ("getFilesAndDirectories" in e.dataTransfer) {
            const filesAndDirs = await e.dataTransfer.getFilesAndDirectories()
            const fileList = await Utils.getFilesFromDirs(filesAndDirs, "/")
            console.log('===handleDrop===')
            uploadDebounce(fileList[0], fileList)
            return false
        }
    }
    const handleModalUpload = useCallback(async (file) => {
        const uploadedKeys = await doUploadFiles([file])
        return uploadedKeys.length > 0
    }, [doUploadFiles])
    const handleFolderToggle = (nodeData, e) => {
        e.stopPropagation()
        const isExpanded = expandedKeys.includes(nodeData.key)
        const newKeys = isExpanded
            ? expandedKeys.filter(k => k !== nodeData.key)
            : [...expandedKeys, nodeData.key]
        setExpandedKeys(newKeys)
    }
    const expandFolderAncestors = useCallback((folderId) => {
        if (!folderId || folderId === 'refImage_all') return
        const ancestors = getAncestorKeysByFolderId(folderList, folderId) || []
        if (!ancestors.length) return
        setExpandedKeys(prev => Array.from(new Set([...(prev || []), ...ancestors])))
    }, [folderList])
    const handleFolderSelect = (folderId, folderName) => {
        setActiveFolder(folderId)
        setActiveFolderName(folderName)
        expandFolderAncestors(folderId)
        setFolderOpen(false)
    }
    const folderTitleRender = (nodeData) => {
        const isActive = activeFolder === nodeData.key
        const isExpanded = expandedKeys.includes(nodeData.key)
        const hasChildren = nodeData.children && nodeData.children.length > 0
        const icon = isActive || (hasChildren && isExpanded)
            ? <Iconfont type="icon-Material-FolderOpenOutlined" />
            : <Iconfont type="icon-Material-FolderOutlined" />
        return (
            <div style={{ display: 'flex', width: '100%', overflow: 'hidden', minWidth: 0 }}>
                <div className={`${styles.treeNodeContent} ${isActive ? styles.activeNode : ''}`} style={{ flex: 1, minWidth: 0 }}>
                    {hasChildren ? (
                        <span
                            className={`${styles.customSwitcher} ${isExpanded ? styles.expanded : ''}`}
                            onClick={(e) => handleFolderToggle(nodeData, e)}
                        >
                            <CaretDownOutlined />
                        </span>
                    ) : (
                        <span className={styles.switcherPlaceholder} />
                    )}
                    <span className={styles.nodeIcon}>{icon}</span>
                    <span className={styles.nodeTitle}>{nodeData.title}</span>
                    <span className={styles.nodeCount}>{nodeData.count}</span>
                </div>
            </div>
        )
    }
    const handleShare = (record) => {
        const isLogin = Utils.checkLoginStatus(() => handleShare(record))
        if (!isLogin) return
        if (globalOrgInfo?.isPersonal) {
            if (hasOrg) eventBus.emit('OPEN_SELECT_TEAM', { type: SELECT_ORG_TYPE.CHANGEORG, noPersonal: true })
            else eventBus.emit('OPEN_CREATE_TEAM')
            return
        }
        setCurrentMoveResId(record.id)
        setShareOpen(true)
    }
    const handleMove = (record) => {
        setCurrentMoveResId(record.id)
        setMoveOpen(true)
    }
    const handleRemove = (record) => {
        const removeLabel = getDeleteResourceLabel(props.projectType)
        PSAIModal.confirm({
            content: (
                <div style={{ textAlign: 'center' }}>
                    <p>{`确定要删除此${removeLabel}吗？`}</p>
                    <p style={{ color: '#FF3B30' }}>此操作不可复原，请确认是否删除</p>
                </div>
            ),
            onOk() {
                const api = customByMaterialList ? API.removeCustomMaterial({ id: record.id }) : API.removeCustomResources({ resourceIds: [record.id] })
                return commonApiInvoker(api).then(() => {
                    message.success('删除成功')
                    removeRecordsFromList([record])
                    if (props.value.find(item => item.key == getSelectKey(record))) props.onClick(record)
                })
            },
            onCancel() { },
        })
    }
    const handleFavor = (record) => {
        const params = getResourceQueryParams(props.projectType)
        const resourceKey = getSelectKey(record)
        if (record.isFavorite) {
            const apiPromise = API.unfavoriteResource2({
                ...params,
                resourceId: [record.id],
                resourceKey: [resourceKey],
                custom: !!record?.attr?.custom,
            })
            commonApiInvoker(apiPromise).then(() => {
                message.success("已取消收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = false
                    return [...temp]
                })
            })
        } else {
            const apiPromise = API.favoriteResource2({
                ...params,
                resourceId: record.id,
                resourceKey,
                custom: !!record?.attr?.custom,
            })
            commonApiInvoker(apiPromise).then(() => {
                message.success("已收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = true
                    return [...temp]
                })
            })
        }
    }

    const modelFormRef = useRef()
    const [open, setOpen] = useState(false)
    const handleNewModel = () => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => handleNewModel())
        if (!status) return

        setOpen(true)
    }
    const handelOk = async () => {
        try {
            setLoading(true)
            const res = await modelFormRef.current.onSubmit()
            if (res) {
                message.success('模特添加成功')
                pendingAutoSelectIdRef.current = res
                setOpen(false)
                updateForce()
            }
        } catch (err) {
            message.warning(err.message)
        } finally {
            setLoading(false)
        }
    }

    const uploadRequireResourceType = useMemo(() => {
        if (props.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH) return RESOURCE_TYPE.MODEL
        if (props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) return RESOURCE_TYPE.MODEL_SCENE
        return RESOURCE_TYPE.TRYON_MODEL
    }, [props.projectType])

    const showUploadRequire = useMemo(() => {
        return uploadRequireResourceType != RESOURCE_TYPE.TRYON_SHOES &&
            uploadRequireResourceType != RESOURCE_TYPE.MODEL_SCENE &&
            uploadRequireResourceType != RESOURCE_TYPE.COMMODITY_SCENE &&
            uploadRequireResourceType != RESOURCE_TYPE.TRYON_SCENE &&
            uploadRequireResourceType != RESOURCE_TYPE.GLASSES_TRYON
    }, [uploadRequireResourceType])

    return (
        <>
            <div className={`_beauty_scrollbar`} style={{ ...props.style, paddingRight: 4 }} onScroll={handleListScroll}>
                {showEnterpriseEmpty ? (
                    <EnterpriseEmpty />
                ) : (
                    <>
                {customByMaterialList && (
                    <div className={styles.CustomHeader}>
                        <Popover
                            trigger="click"
                            placement="bottomLeft"
                            open={folderOpen}
                            onOpenChange={setFolderOpen}
                            arrow={false}
                            classNames={{ root: styles.FolderPopover }}
                            content={(
                                <div className={`${styles.folderDropdown} _beauty_scrollbar`}>
                                    <div
                                        className={`${styles.treeNodeContent} ${activeFolder === 'refImage_all' ? styles.activeNode : ''}`}
                                        onClick={() => handleFolderSelect('refImage_all', '全部参考图')}
                                    >
                                        <span className={styles.switcherPlaceholder} />
                                        <span className={styles.nodeIcon}>
                                            {activeFolder === 'refImage_all'
                                                ? <Iconfont type="icon-Material-FolderOpenOutlined" />
                                                : <Iconfont type="icon-Material-FolderOutlined" />}
                                        </span>
                                        <span className={styles.nodeTitle}>全部参考图</span>
                                        <span className={styles.nodeCount}>{folderTotal}</span>
                                    </div>
                                    <Tree
                                        treeData={treeData}
                                        expandedKeys={expandedKeys}
                                        onExpand={(keys) => setExpandedKeys(keys)}
                                        selectedKeys={activeFolder === 'refImage_all' ? [] : [activeFolder]}
                                        onSelect={(selectedKeys, info) => {
                                            if (selectedKeys.length > 0) {
                                                handleFolderSelect(selectedKeys[0], info?.node?.title || '')
                                            }
                                        }}
                                        titleRender={folderTitleRender}
                                        blockNode
                                        showIcon={false}
                                        switcherIcon={null}
                                        className={styles.customTree}
                                    />
                                </div>
                            )}
                        >
                            <div className={styles.folderSelect} title={activeFolderName}>
                                <span className={styles.folderSelectName}>{activeFolderName}</span>
                                <CaretDownOutlined className={`${styles.folderSelectArrow} ${folderOpen ? styles.open : ''}`} />
                            </div>
                        </Popover>
                        <Input
                            className={styles.customSearchInput}
                            placeholder="搜索内容"
                            prefix={<SearchOutlined style={{ color: '#BFBFBF' }} />}
                            value={customKeyword}
                            onChange={e => setCustomKeyword(e.target.value)}
                            onPressEnter={() => setCustomKeyword(customKeyword)}
                            allowClear
                        />
                    </div>
                )}
                {!props.hideUploadTrigger && <div className={styles.SelectTryonPose}>
                    {
                        props.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ?
                            <div className={styles.UploadTriggerBatch} onClick={handleNewModel}>
                                <div className={styles.UploadContentBatch}>
                                    {loading ? <LoadingOutlined /> : <PlusOutlined />}
                                    <div className={styles.UploadContentExtra}>新增模特</div>
                                    {showUploadRequire &&
                                        <Popover
                                            trigger="hover"
                                            placement="bottomLeft"
                                            arrow={false}
                                            content={<UploadRequirements resourceType={uploadRequireResourceType} />}
                                            onClick={e => e.stopPropagation()}
                                        >
                                            <span className={styles.RequireTrigger}>图片要求</span>
                                        </Popover>}
                                </div>
                            </div> :
                            <div className={styles.UploadWrapBatch} onClick={() => setUploadModalOpen(true)}>
                                <div className={styles.UploadContentBatch}>
                                    {loading ? <LoadingOutlined /> : <PlusOutlined />}
                                    <div className={styles.UploadContentExtra}>
                                        <span style={{ fontSize: 14, display: "block", color: "#5B6673", whiteSpace: "nowrap", marginBottom: 5 }}>{loading ? `已上传 ${succNum}/${totalNum}` : "点击上传"}</span>
                                        {/* <span style={{ fontSize: 14, display: "block", color: "#5B6673", whiteSpace: "nowrap" }}>最多30张/次</span> */}
                                    </div>
                                </div>
                            </div>
                    }
                </div>}
                {
                    list.map(item => (
                        item.type === 'folder' ?
                            <ReferFolderCard
                                key={item.id}
                                item={item}
                                className={styles.BatchReferFolderCard}
                                onClick={() => handleFolderSelect(item.id, item.name)}
                            /> :
                        <ImageItem
                            key={item.id}
                            hideCustomIcon
                            showTitle
                            hideToolActions={props.hideItemActions}
                            projectType={props.projectType}
                            toolGroup={props.hideItemActions ? null :
                                item.attr?.maskStatus == "failed" ? {
                                    onRemove: () => handleRemove(item)
                                } : {
                                    onFavor: () => handleFavor(item),
                                    onPreview: true,
                                    onRemove: () => handleRemove(item),
                                    onMove: customByMaterialList ? () => handleShare(item) : null,
                                    onSort: customByMaterialList ? () => handleMove(item) : null,
                                }}
                            disabled={!(item?.attr && "maskStatus" in item.attr ? item.attr?.maskStatus == "succeeded" : true)}
                            record={item}
                            selectList={props.value}
                            maxCount={props.maxCount}
                            onClick={props.onClick}
                        />
                    ))
                }
                {listLoading && list.length === 0 && (
                    <div className={styles.SelectionListEmpty}>
                        <LoadingOutlined />
                        <span>加载中...</span>
                    </div>
                )}
                {!listLoading && !loadingMore && list.length === 0 && (
                    <div className={styles.SelectionListEmpty}>
                        <img src="https://photostudio-ai.oss-cn-hangzhou.aliyuncs.com/photostudio-web/admin/images_v3/icon_empty.svg" alt="" />
                        <span>这里什么也没有哦~</span>
                    </div>
                )}
                    </>
                )}
            </div>
            <MoveFolderModal
                open={moveOpen}
                mode="res"
                menuList={folderList}
                resIds={currentMoveResId ? [currentMoveResId] : []}
                onSuccess={() => {
                    setMoveOpen(false)
                    setCurrentMoveResId('')
                    updateForce()
                }}
                onCancel={() => {
                    setMoveOpen(false)
                    setCurrentMoveResId('')
                }}
            />
            <MoveFolderModal
                open={shareOpen}
                mode="share"
                resIds={currentMoveResId ? [currentMoveResId] : []}
                shareScope="enterprise"
                zIndex={1010}
                onSuccess={() => {
                    setShareOpen(false)
                    setCurrentMoveResId('')
                }}
                onCancel={() => {
                    setShareOpen(false)
                    setCurrentMoveResId('')
                }}
            />
            <PSAIModal
                getContainer={document.body}
                title="新增模特"
                maxWidth={586}
                open={open}
                confirmLoading={loading}
                onOk={handelOk}
                onCancel={() => setOpen(false)}
            >
                <CustomModelForm ref={modelFormRef} />
            </PSAIModal>
            <MaterialUploadModal
                open={uploadModalOpen}
                resourceType={getResourceTypeByProjectType(props.projectType)}
                sampleType={getUploadSampleTypeByProjectType(props.projectType)}
                onUpload={handleModalUpload}
                onSuccess={() => {
                    updateForce()
                }}
                onCancel={() => setUploadModalOpen(false)}
            />
        </>
    )
})

const FavoritePoseList = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        refresh: () => updateForce()
    }))

    const [list, setList] = useState([])
    const [force, setForce] = useState(0)
    const updateForce = useCallback(() => setForce(prev => prev + 1), [])
    useEffect(() => {
        if (props.activeKey != "favorite") return
        props.onChange(list)
    }, [props.activeKey, list])
    const [pageIndex, setPageIndex] = useState(1)
    const [hasMore, setHasMore] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const requestIdRef = useRef(0)
    const loadingMoreRef = useRef(false)

    useEffect(() => {
        loadingMoreRef.current = loadingMore
    }, [loadingMore])

    const loadFavoriteListPage = useCallback((targetPageIndex, reset = false) => {
        if (props.activeKey != "favorite") return
        if (loadingMoreRef.current && !reset) return
        const params = {}
        const resourceType = getResourceTypeByProjectType(props.projectType)
        if (resourceType == RESOURCE_TYPE.MODEL) params.filterByFuncType = true
        const resourceParams = getResourceQueryParams(props.projectType)
        const requestId = requestIdRef.current + 1
        requestIdRef.current = requestId
        if (reset) {
            setPageIndex(1)
            setHasMore(false)
        } else {
            setLoadingMore(true)
        }
        commonApiInvoker(API.getFavoriteResources2({
            ...resourceParams,
            pageIndex: targetPageIndex,
            pageSize: PAGE_SIZE,
            ...params,
        })).then(res => {
            if (requestIdRef.current !== requestId) return
            const total = res?.total || 0
            const nextList = (res?.items ?? []).filter(item => item.name != "00_default_style")
                .map(item => ({ ...item, key: getSelectKey(item), isFavorite: true }))
                .map(item => ({
                    ...item,
                    attr: {
                        ...item.attr,
                        title: item?.name || item?.attr?.title || '',
                        custom: item?.attr && "custom" in item.attr ? item.attr.custom : item.attr?.skin == "custom"
                    }
                }))
            if (reset) {
                setList(nextList)
            } else {
                setList(prev => [...prev, ...nextList])
            }
            setPageIndex(targetPageIndex)
            setHasMore(targetPageIndex * PAGE_SIZE < total)
        }).finally(() => {
            if (requestIdRef.current !== requestId) return
            setLoadingMore(false)
        })
    }, [props.activeKey, props.projectType])

    useEffect(() => {
        loadFavoriteListPage(1, true)
    }, [force, props.projectType, props.activeKey, loadFavoriteListPage])
    const handleFavor = (record) => {
        const params = getResourceQueryParams(props.projectType)
        const resourceKey = getSelectKey(record)
        if (record.isFavorite) {
            commonApiInvoker(API.unfavoriteResource2({
                ...params,
                resourceId: [record.id],
                resourceKey: [resourceKey],
                custom: !!record?.attr?.custom,
            })).then(res => {
                message.success("已取消收藏")
                setList(prev => prev.filter(item => item.id != record.id))
                props.onFavor(record, false)
            })
        } else {
            commonApiInvoker(API.favoriteResource2({
                ...params,
                resourceId: record.id,
                resourceKey,
                custom: !!record?.attr?.custom,
            })).then(res => {
                message.success("已收藏")
                updateForce()
                props.onFavor(record, true)
            })
        }
    }
    const handleRemove = (record) => {
        const removeLabel = getDeleteResourceLabel(props.projectType)
        PSAIModal.confirm({
            content: (
                <div style={{ textAlign: 'center' }}>
                    <p>{`确定要删除此${removeLabel}吗？`}</p>
                    <p style={{ color: '#FF3B30' }}>此操作不可复原，请确认是否删除</p>
                </div>
            ),
            onOk() {
                return commonApiInvoker(API.removeCustomMaterial({
                    id: record.id
                })).then(() => {
                    message.success('删除成功')
                    updateForce({})
                    if (props.value.find(item => item.key == getSelectKey(record))) props.onClick(record)
                })
            },
            onCancel() { },
        })
    }
    const handleListScroll = useCallback((e) => {
        if (props.activeKey != "favorite") return
        const target = e.currentTarget
        const reachBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 80
        if (!reachBottom) return
        if (!hasMore || loadingMore) return
        loadFavoriteListPage(pageIndex + 1, false)
    }, [props.activeKey, hasMore, loadingMore, pageIndex, loadFavoriteListPage])

    return (
        <>
            <div className={`_beauty_scrollbar`} style={{ ...props.style, paddingRight: 4 }} onScroll={handleListScroll}>
                {
                    list.map(item => (
                        <ImageItem
                            key={item.id}
                            hideToolActions={props.hideItemActions}
                            projectType={props.projectType}
                            toolGroup={props.hideItemActions ? null : {
                                onPreview: true,
                                onFavor: () => handleFavor(item),
                                onRemove: () => handleRemove(item)
                            }}
                            record={item}
                            selectList={props.value}
                            maxCount={props.maxCount}
                            onClick={props.onClick}
                        />
                    ))
                }
            </div>
        </>
    )
})

const PoseList = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        refresh: () => updateForce({}),
        onFavor: (record, favor) => {
            setList(pre => {
                const temp = [...pre]
                const item = temp.find(item => item.id == record.id)
                if (!item) return temp
                item.isFavorite = favor
                return [...temp]
            })
        }
    }))
    const [force, updateForce] = useState()
    const [list, setList] = useState([])
    const [pageIndex, setPageIndex] = useState(1)
    const [hasMore, setHasMore] = useState(false)
    const [loadingMore, setLoadingMore] = useState(false)
    const requestIdRef = useRef(0)
    const loadingMoreRef = useRef(false)
    const activeRequestKeyRef = useRef('')

    useEffect(() => {
        if (props.activeKey != "custom" && props.activeKey != "enterpriseCustom") return
        props.onChange(list)
    }, [props.activeKey, list])

    useEffect(() => {
        loadingMoreRef.current = loadingMore
    }, [loadingMore])

    const loadPresetListPage = useCallback((targetPageIndex, reset = false) => {
        if (props.activeKey != "default") return
        if (loadingMoreRef.current && !reset) return
        const requestKey = JSON.stringify({
            pageIndex: targetPageIndex,
            projectType: props.projectType,
            filter: props.filter || {},
        })
        if (activeRequestKeyRef.current === requestKey) return
        activeRequestKeyRef.current = requestKey
        const requestId = requestIdRef.current + 1
        requestIdRef.current = requestId
        if (reset) {
            setPageIndex(1)
            setHasMore(false)
        } else {
            setLoadingMore(true)
        }
        const params = {}
        const { sex, skin, age, shoesType, pose, clothesCate, toneTags, text, sceneTags, compositionTags } = props.filter
        if (age?.length > 0) params.age = age?.join()
        if (sex?.length > 0) params.sex = sex?.join()
        if (skin?.length > 0) params.skin = skin?.join()
        if (toneTags?.length > 0) params.toneTags = toneTags?.join()
        if (shoesType?.length > 0) params.shoesType = shoesType?.join()
        if (pose?.length > 0) params.poseType = pose?.join()
        if (clothesCate?.length > 0) params.clothesCate = clothesCate?.join()
        if (text?.length > 0) params.text = text
        if (sceneTags?.length > 0) params.sceneTags = sceneTags?.join()
        if (compositionTags?.length > 0) params.compositionTags = compositionTags?.join()
        const data = getResourceData(props.projectType)
        commonApiInvoker(API.getPresetResources2({
            ...data,
            ...params,
            pageIndex: targetPageIndex,
            pageSize: PAGE_SIZE
        })).then(res => {
            if (requestIdRef.current !== requestId) return
            const total = res?.total || 0
            const nextList = (res?.items ?? [])
                .filter(item => (!item.name.includes("_random") && !item.name.includes("_keep") && !item.name.includes("_default_style")))
                .map(item => ({
                    ...item,
                    isFavorite: item.attr.isFavorite,
                    attr: {
                        ...item.attr,
                        title: item?.name || item?.attr?.title || '',
                        custom: false
                    }
                }))
            if (reset) {
                setList(nextList)
            } else {
                setList(prev => [...prev, ...nextList])
            }
            setPageIndex(targetPageIndex)
            setHasMore(targetPageIndex * PAGE_SIZE < total)
        }).finally(() => {
            if (requestIdRef.current !== requestId) return
            if (activeRequestKeyRef.current === requestKey) {
                activeRequestKeyRef.current = ''
            }
            setLoadingMore(false)
        })
    }, [props.activeKey, props.filter, props.projectType])

    useEffect(() => {
        loadPresetListPage(1, true)
    }, [force, props.filter, props.activeKey, loadPresetListPage])

    const handleListScroll = useCallback((e) => {
        if (props.activeKey != "default") return
        const target = e.currentTarget
        const reachBottom = target.scrollTop + target.clientHeight >= target.scrollHeight - 80
        if (!reachBottom) return
        if (!hasMore || loadingMore) return
        loadPresetListPage(pageIndex + 1, false)
    }, [props.activeKey, hasMore, loadingMore, pageIndex, loadPresetListPage])
    const handleFavor = (record) => {
        const params = getResourceQueryParams(props.projectType)
        const resourceKey = getSelectKey(record)
        if (record.isFavorite) {
            commonApiInvoker(API.unfavoriteResource2({
                ...params,
                resourceId: [record.id],
                resourceKey: [resourceKey],
                custom: false,
            })).then(res => {
                message.success("已取消收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = false
                    return [...temp]
                })
            })
        } else {
            commonApiInvoker(API.favoriteResource2({
                ...params,
                resourceId: record.id,
                resourceKey,
                custom: false,
            })).then(res => {
                message.success("已收藏")
                setList(pre => {
                    const temp = [...pre]
                    const item = temp.find(item => item.id == record.id)
                    item.isFavorite = true
                    return [...temp]
                })
            })
        }
    }
    return (
        <>
            <div className={`_beauty_scrollbar`} style={{ ...props.style, paddingRight: 4 }} onScroll={handleListScroll}>
                {
                    list.map(item => (
                        <ImageItem
                            key={item.id}
                            hideToolActions={props.hideItemActions}
                            projectType={props.projectType}
                            toolGroup={props.hideItemActions ? null : {
                                onPreview: true,
                                onFavor: () => handleFavor(item),
                            }}
                            record={item}
                            selectList={props.value}
                            maxCount={props.maxCount}
                            onClick={props.onClick}
                        />
                    ))
                }
            </div>
        </>
    )
})

// 选择tryon姿势
const SelectTryonPose = forwardRef((props, ref) => {
    // props.readOnly
    // props.value
    // props.projectType
    const { drawOpen } = props
    const allowedTabs = useMemo(() => props.allowedTabs || null, [props.allowedTabs])
    const getInitialActiveKey = useCallback(() => {
        const defaultKey = "default"
        if (!allowedTabs?.length) return defaultKey
        return allowedTabs.includes(defaultKey) ? defaultKey : allowedTabs[0]
    }, [allowedTabs, props.projectType])
    const [value, setValue] = useState(Array.isArray(props.value) ? [...props.value] : [])
    const valueRef = useRef(value)
    useEffect(() => {
        valueRef.current = value
    }, [value])
    const [activeKey, setActiveKey] = useState(getInitialActiveKey)
    const [filter, setFilter] = useState({
        skin: [], // 肤色
        sex: [], // 性别
        age: [], // 年龄
        toneTags: [], // 气质类型
        shoesType: [], // 品类 
        pose: [], // 姿势
        clothesCate: [], // 服饰品类
        text: "", // 搜索
        sceneTags: [], // 背景类别
        compositionTags: [], // 构图
    })
    const handleFilterChange = (filter) => {
        setFilter(pre => ({ ...pre, ...filter }))
    }

    const handleTabChange = (key) => {
        setActiveKey(key)
        setFilter(pre => ({ ...pre, text: "" }))
    }

    const handleClick = useCallback((record) => {
        if (props.readOnly) return
        const selectKey = getSelectKey(record)
        setValue(pre => {
            if (pre.find(item => item.key == selectKey)) {
                return pre.filter(item => item.key != selectKey)
            }
            const item = { key: selectKey }
            item.url = record.attr?.custom ? (record.attr.tryOnImage || record.imageUrl) : record.imageUrl
            item.custom = record.attr?.custom ? 1 : 0 // 0-预设 1-自定义
            item.colorMask = record.attr?.custom ? record.attr.colorMask : null
            item.title = record.attr?.title ? record.attr.title : null
            item.attr = record.attr || {}
            item.detailPageNum = Number(record?.attr?.detailPageNum) || 0
            return [...pre, item].slice(props.maxCount == -1 ? 0 : -props.maxCount)
        })
    }, [props.readOnly, props.projectType, props.maxCount])

    const style = {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        alignContent: "flex-start",
        height: `calc(100vh - 180px)`,
        maxHeight: `calc(100vh - 180px)`,
        minHeight: `calc(100vh - 180px)`,
        gap: "10px"
    }

    const [displayList, setDisplayList] = useState([])
    const [prompt, setPrompt] = useState(typeof props.value === 'string' ? props.value : '')
    const handleChange = (list) => {
        setDisplayList(list)
    }

    useEffect(() => {
        if (props.projectType != BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
            setValue(Array.isArray(props.value) ? [...props.value] : [])
        }
    }, [props.projectType, props.value, drawOpen])

    useEffect(() => {
        if (props.projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
            setPrompt(typeof props.value === 'string' ? props.value : '')
        }
    }, [props.projectType, props.value, drawOpen])

    useEffect(() => {
        const nextActiveKey = getInitialActiveKey()
        if (allowedTabs?.length && !allowedTabs.includes(activeKey)) {
            setActiveKey(nextActiveKey)
            return
        }
        if (!activeKey) {
            setActiveKey(nextActiveKey)
        }
    }, [activeKey, allowedTabs, getInitialActiveKey])

    const handleOk = () => {
        if (props.projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH) {
            props.onChange(prompt)
            props.onClose()
            return
        }
        props.onChange([...valueRef.current])
        props.onClose()
    }

    const handleUsePrompt = () => {
        const nextPrompt = (prompt || '').trim()
        if (props.onApplyImageToVideoPrompt) {
            props.onApplyImageToVideoPrompt(nextPrompt)
        } else {
            props.onChange(nextPrompt)
        }
        props.onClose()
    }

    const customRef = useRef()
    const enterpriseRef = useRef()
    const defaultRef = useRef()
    const favorRef = useRef()

    useImperativeHandle(ref, () => ({
        refresh: () => {
            customRef.current?.refresh?.()
            enterpriseRef.current?.refresh?.()
            defaultRef.current?.refresh?.()
            favorRef.current?.refresh?.()
        },
        uploadAndConfirm: async (fileList) => {
            if (!fileList?.length) return
            setActiveKey(allowedTabs?.includes("custom") === false ? getInitialActiveKey() : "custom")
            await new Promise(r => setTimeout(r, 0))
            const selectedKeys = await customRef.current?.uploadFiles?.(fileList)
            const lastKey = selectedKeys?.[selectedKeys.length - 1]
            if (lastKey) {
                const startAt = Date.now()
                while (Date.now() - startAt < 2000) {
                    if (valueRef.current.find(item => item.key == lastKey)) break
                    await new Promise(r => setTimeout(r, 16))
                }
            }
            props.onChange([...valueRef.current])
            props.onClose?.()
        }
    }))

    const handleDeleteBatch = () => {
        const removeLabel = getDeleteResourceLabel(props.projectType)
        const displayRecords = []
        for (let item of value) {
            const displayItem = displayList.find(item2 => getSelectKey(item2) == item.key)
            if (!displayItem) continue
            displayRecords.push(displayItem)
        }
        const deleteRecords = displayRecords.filter(item => item.attr?.custom)
        if (deleteRecords.length == 0) return message.warning(`当前页的预设${removeLabel}不可删除`)
        const title = displayRecords.length == deleteRecords.length ?
            `确定删除当前页选中的 ${deleteRecords.length} 张自定义${removeLabel}？` :
            "确定要删除吗？"
        const content = displayRecords.length == deleteRecords.length ? "" :
            <span style={{ whiteSpace: "pre-wrap" }}>{`预设${removeLabel}不可删除，仅可删除当前页选中的 ${deleteRecords.length} 张自定义${removeLabel}。`}</span>
        PSAIModal.confirm({
            title: title,
            content: content,
            onOk() {
                return commonApiInvoker(API.removeCustomResources({ resourceIds: deleteRecords.map(item => item.id) })).then(() => {
                    message.success('删除成功')
                    const otherList = value.filter(item => !deleteRecords.find(item2 => getSelectKey(item2) == item.key))
                    setValue([...otherList])
                    if (activeKey == "custom") customRef.current?.removeRecords?.(deleteRecords)
                    else if (activeKey == "enterpriseCustom") enterpriseRef.current?.removeRecords?.(deleteRecords)
                    else favorRef.current?.refresh()
                })
            },
            onCancel() { },
        })
    }
    const handleUnfavorBatch = () => {
        const displayRecords = []
        for (let item of value) {
            const displayItem = displayList.find(item2 => getSelectKey(item2) == item.key)
            if (!displayItem) continue
            displayRecords.push(displayItem)
        }
        const favorRecords = displayRecords.filter(item => item.isFavorite)
        if (favorRecords.length == 0) return message.warning("当前页没有选择已收藏的姿势")
        const resourceType = getResourceTypeByProjectType(props.projectType)
        const params = { ...(RESOURCE_PARAMS[resourceType] || {}) }
        const resourceList = favorRecords.map(item => item.id)
        const resourceKeyList = favorRecords.map(item => getSelectKey(item))
        commonApiInvoker(API.unfavoriteResource2({
            ...params,
            resourceId: resourceList,
            resourceKey: resourceKeyList,
        })).then(res => {
            message.success("已取消收藏")
            if (activeKey == "custom") customRef.current?.refresh()
            else if (activeKey == "enterpriseCustom") enterpriseRef.current?.refresh()
            else if (activeKey == "default") defaultRef.current?.refresh()
            else {
                defaultRef.current?.refresh()
                favorRef.current?.refresh()
            }
        })
    }

    const handleFavor = (record, faovr) => {
        defaultRef.current?.onFavor(record, faovr)
    }

    const handleRemove = ({ key }) => {
        setValue(value.filter(item => item.key != key))
    }

    // 背景筛选
    const [modelSceneTypeOpts, setModelSceneTypeOpts] = useState([])
    const [modelCompositionTypeOpts, setModelCompositionTypeOpts] = useState([])
    useEffect(() => {
        if (props.projectType != BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH) return
        Promise.all([
            API.categoryList({
                func: 'background',
                category: 'sceneTags',
                resourceType: 'model',
            }),
            API.categoryList({
                func: 'background',
                category: 'compositionTags',
                resourceType: 'model',
            })
        ]).then(([res1, res2]) => {
            const modelSceneTypeOpts = res1.data.map((item) => {
                return {
                    label: item.display,
                    title: item.display,
                    options: item.subList.map(opt => ({
                        label: opt.display,
                        value: item.display + '/' + opt.value,
                    })),
                }
            })
            const modelCompositionTypeOpts = res2.data
            setModelSceneTypeOpts(modelSceneTypeOpts || [])
            setModelCompositionTypeOpts(modelCompositionTypeOpts || [])
        })
    }, [])

    const sceneType = (
        <div className={styles.sceneTypeWrap}>
            <Select
                placeholder="构图"
                mode="multiple"
                allowClear={true}
                size="small"
                maxTagCount='responsive'
                style={{ width: 140, height: 32, marginRight: '12px' }}
                onChange={(value) => handleFilterChange({ compositionTags: value })}
                options={modelCompositionTypeOpts}
            />
            <Select
                placeholder="背景类型"
                mode="multiple"
                allowClear={true}
                size="small"
                maxTagCount='responsive'
                style={{ width: 140, height: 32, marginRight: '12px' }}
                onChange={(value) => handleFilterChange({ sceneTags: value })}
                options={modelSceneTypeOpts}
            />
            <SelectionFilterSearch onChange={value => handleFilterChange({ text: value })} />
        </div>

    )
    const operations = (
        <div className={styles.OperationsBatch}>
            {
                activeKey == "default" &&
                <div className={styles.operationsWrap}>
                    {
                        props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ?
                            sceneType :
                            props.projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ?
                                null :
                            props.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH || props.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ?
                                <ModelFilterSelection filterValue={filter} imageType={IMAGE_TYPE.CLOTHES} isPose onChange={handleFilterChange} /> :
                                <ModelFilterSelectionNew filterValue={filter} imageType={IMAGE_TYPE.CLOTHES} onChange={handleFilterChange} />
                    }
                </div>
            }
            {/* <div style={{ display: "flex", justifyContent: "flex-end", gap: 10 }}>
                <Button style={{ lineHeight: 1 }} disabled={value.length == 0} size="small" onClick={handleUnfavorBatch}>取消收藏</Button>
                {
                    activeKey != "default" &&
                    <Button style={{ lineHeight: 1 }} disabled={value.length == 0} size="small" onClick={handleDeleteBatch}>删除</Button>
                }
            </div> */}
        </div>
    )

    const selectedListRender = useMemo(() => (
        <div className={`${styles.SelectedListBatch} ${props.selectedListScrollable ? `${styles.SelectedListBatchScrollable} _beauty_scrollbar` : ''}`}>
            {
                value.map(item => {
                    return (
                        <div key={item.key} className={styles.SelectedItem}>
                            <Image src={Utils.getImgThumbnail(item.url)} fallback={fallback} preview={false} />
                            <Iconfont onClick={() => handleRemove(item)} className={styles.Icon} type="icon-DeleteOutlined" />
                        </div>
                    )
                })
            }
        </div>
    ), [value])

    const title = useMemo(() => {
        return props.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ? "姿势" :
            props.projectType == BATCH_IMAGES_TYPE.CHANGE_MODEL_BATCH ? "模特" :
                props.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? "模特" :
                        props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ? "背景" : ""

    }, [props.projectType])

    const imageToVideoItems = [{
        key: 'prompt',
        label: `预设词库`,
        children: <ImgToVideoContent type='prompt' resourceType={RESOURCE_TYPE.IMAGE_TO_VIDEO} setPrompt={setPrompt} />,
        destroyOnHidden: true
    }, {
        key: 'mine',
        label: `我的模板`,
        children: <ImgToVideoContent type='mine' resourceType={RESOURCE_TYPE.IMAGE_TO_VIDEO} setPrompt={setPrompt} />,
        destroyOnHidden: true
    }]

    const customUseMaterialList = props.projectType == BATCH_IMAGES_TYPE.CHANGE_BKG_BATCH ||
        props.projectType == BATCH_IMAGES_TYPE.TRYON_BATCH ||
        props.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ||
        props.projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH
    const showEnterpriseCustomTab = customUseMaterialList

    const items = [{
        key: "default",
        label: props.projectType == BATCH_IMAGES_TYPE.SMART_DETAIL_PAGE_BATCH ? "预设详情页" : `预设${title}`,
        children: (
            <PoseList
                maxCount={props.maxCount}
                ref={defaultRef}
                projectType={props.projectType}
                hideItemActions={props.hideItemActions}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
                filter={filter}
            />
        ),
    }, {
        key: "custom",
        label: props.projectType == BATCH_IMAGES_TYPE.FUSIONWEAR_BATCH ? "个人参考图" : (title == '模特' ? `自定义${title}` : "个人参考图"),
        children: (
            <CustomPoseList
                ref={customRef}
                maxCount={props.maxCount}
                projectType={props.projectType}
                hideUploadTrigger={props.hideUploadTrigger}
                hideItemActions={props.hideItemActions}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
                materialScope="personal"
            />
        ),
        destroyOnHidden: true
    }, ...(showEnterpriseCustomTab ? [{
        key: "enterpriseCustom",
        label: "企业参考图",
        children: (
            <CustomPoseList
                ref={enterpriseRef}
                maxCount={props.maxCount}
                projectType={props.projectType}
                hideUploadTrigger={props.hideUploadTrigger}
                hideItemActions={props.hideItemActions}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
                materialScope="enterprise"
            />
        ),
        destroyOnHidden: true
    }] : []), {
        key: "favorite",
        label: "我的收藏",
        children: (
            <FavoritePoseList
                maxCount={props.maxCount}
                ref={favorRef} 
                projectType={props.projectType}
                hideItemActions={props.hideItemActions}
                activeKey={activeKey}
                value={value}
                style={style}
                onClick={handleClick}
                onChange={handleChange}
                onFavor={handleFavor}
            />
        ),
        destroyOnHidden: true
    }].filter(item => !allowedTabs?.length || allowedTabs.includes(item.key))

    return (
        <>
            <div className={styles.SelectTryonPoseWrap}>
                <CloseOutlined className={styles.CloseIcon} onClick={() => props.setDrawOpen(false)} />
                <div className={styles.PoseLeft}>
                    {
                        props.projectType == BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH ?
                            <div className={styles.ImgToVideoWrap}>
                                <Tabs
                                    size="small"
                                    defaultActiveKey="prompt"
                                    items={imageToVideoItems}
                                    className={styles.ImgToVideoTabs}
                                />
                                <div className={styles.ImgToVideoResultWrap}>
                                    <div className={styles.ImgToVideoResultTitle}>组合结果</div>
                                    <div className={styles.ImgToVideoResultInputWrap}>
                                        <Input.TextArea
                                            value={prompt}
                                            onChange={(e) => setPrompt(e.target.value)}
                                            placeholder="请从预设词库中选择词汇进行组合"
                                            maxLength={800}
                                            className={styles.ImgToVideoResultInput}
                                        />
                                        <div className={styles.ImgToVideoResultActions}>
                                            <Button className={styles.ImgToVideoResultClear} onClick={() => setPrompt('')}>
                                                <Iconfont type="icon-DeleteOutlined" />
                                            </Button>
                                            <Button type="primary" className={styles.ImgToVideoResultUse} onClick={handleUsePrompt}>
                                                使用描述
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            :
                            <Tabs
                                size="small"
                                activeKey={activeKey}
                                tabBarExtraContent={items.some(item => item.key == "default") ? operations : null}
                                items={items}
                                onChange={handleTabChange}
                            />
                    }
                </div>
                {
                    props.projectType != BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH && props.maxCount > 1 &&
                    <div className={`${styles.PoseRight} ${props.selectedListScrollable ? styles.PoseRightScrollable : '_beauty_scrollbar'}`}>
                        <p style={{ marginBottom: 20 }}>已选参考图 {value.length}/{props.maxCount}</p>
                        {selectedListRender}
                    </div>
                }
            </div>

            {
                props.projectType != BATCH_IMAGES_TYPE.IMAGE_TO_VIDEO_BATCH &&
                <div className={styles.FooterBatch}>
                    <Button style={{ width: 200, height: 36, marginRight: 12 }} onClick={() => props.setDrawOpen(false)}>取消</Button>
                    <Button style={{ width: 200, height: 36 }} type="primary" onClick={handleOk}>确定</Button>
                </div>
            }
        </>

    )
})

export default SelectTryonPose
